import get from 'lodash/get';

const NAMESPACE = 'app';

export const selectAllowAutoplay = (state) =>
  get(state, [NAMESPACE, 'allowAutoplay']);
export const selectBranchUrl = (state) => get(state, [NAMESPACE, 'branchUrl']);
export const selectBreakpoint = (state) =>
  get(state, [NAMESPACE, 'breakpoint']);
export const selectIsDesktop = (state) =>
  get(state, [NAMESPACE, 'isDesktop'], true);
export const selectIsMobile = (state) =>
  get(state, [NAMESPACE, 'isMobile'], false);
export const selectPartnerId = (state) => get(state, [NAMESPACE, 'partnerId']);
export const selectTopBannerHeight = (state) =>
  get(state, [NAMESPACE, 'topBannerHeight']);
export const selectShowPairingSuccessPage = (state) =>
  get(state, [NAMESPACE, 'showPairingSuccessPage'], false);
export const selectTuneInUserSerial = (state) =>
  get(state, [NAMESPACE, 'tuneInUserSerial']);
export const selectUserAgent = (state) => get(state, [NAMESPACE, 'userAgent']);
export const selectShouldShowOneTrustGdprOptOut = (state) =>
  get(state, [NAMESPACE, 'oneTrust', 'gdpr', 'gdprApplies'], false);
